module.exports = __webpack_public_path__ + "media/LandingPageAssets/podcast-b4453d6c.png";